import { connect } from 'react-redux'
import ProcessManager from './component'
import { actions } from '../../../../imports'
import { getAttentionText, getProcessManagerErrorMessage } from '../../../../selectors'

function mapStateToProps(state) {
    return {
        error: {
            title: getAttentionText(state),
            message: getProcessManagerErrorMessage(state),
        },
    }
}

function mapDispatchToProps(dispatch) {
    return {
        updateProcess: (server, userName, isRunning) => {
            dispatch(actions.updateProcess(server, userName, isRunning))
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProcessManager)



// WEBPACK FOOTER //
// ./src/features/Backend/components/Backend/components/ProcessManager/index.js